export default __webpack_public_path__ + "static/media/gas-consumed-icon.a9e28a22.svg";